import React from "react";
import PropTypes from "prop-types";
import {
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "./Dialog.scss";

function Dialog({ open, onClose, title, content, actions, size, fullWidth = true, width, showCloseIcon = false }) {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      maxWidth={width ? false : size}
      fullWidth={width ? false : fullWidth}
      PaperProps={{
        sx: width ? { width, maxWidth: width } : {},
      }}
    >
      <div className="custom-dialog">
        {showCloseIcon && (
          <div className="custom-dialog-close-icon">
            <IconButton onClick={onClose} size="small" aria-label="close">
              <CloseIcon />
            </IconButton>
          </div>
        )}
        {title && title}
        {content && content}
        {actions && actions}
      </div>
    </MuiDialog>
  );
}

Dialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  content: PropTypes.node,
  actions: PropTypes.node,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  width: PropTypes.string,
  showCloseIcon: PropTypes.bool,
};

Dialog.defaultProps = {
  title: null,
  content: null,
  actions: null,
  size: "md",
  width: null,
  showCloseIcon: false,
};

function DialogTitle({ title, showCloseIcon, onClose }) {
  return (
    <div className="flex justify-between items-center gap-1">
      <MuiDialogTitle className="custom-dialog-title">{title}</MuiDialogTitle>
      {showCloseIcon && onClose && (
        <IconButton onClick={onClose} size="small" className="custom-dialog-title-close" aria-label="close">
          <CloseIcon />
        </IconButton>
      )}
    </div>
  );
}

DialogTitle.propTypes = {
  title: PropTypes.string.isRequired,
  showCloseIcon: PropTypes.bool,
  onClose: PropTypes.func,
};

DialogTitle.defaultProps = {
  showCloseIcon: false,
  onClose: null,
};

function DialogContent({ children, dividers }) {
  return (
    <MuiDialogContent className={`custom-dialog-content ${dividers ? "with-dividers" : ""}`}>
      {children}
    </MuiDialogContent>
  );
}

DialogContent.propTypes = {
  children: PropTypes.node.isRequired,
  dividers: PropTypes.bool,
};

DialogContent.defaultProps = {
  dividers: false,
};

function DialogActions({ action1, action2, action3, children }) {
  if (children) {
    return <MuiDialogActions className="custom-dialog-actions">{children}</MuiDialogActions>;
  }

  return (
    <MuiDialogActions className="custom-dialog-actions">
      {action1}
      {action2}
      {action3}
    </MuiDialogActions>
  );
}

DialogActions.propTypes = {
  action1: PropTypes.node,
  action2: PropTypes.node,
  action3: PropTypes.node,
  children: PropTypes.node,
};

DialogActions.defaultProps = {
  action1: null,
  action2: null,
  action3: null,
  children: null,
};

export default Dialog;
export { DialogTitle, DialogContent, DialogActions };
